import React, { useState, useContext } from 'react'
import { makeStyles } from '@material-ui/core'
import Typography from "@material-ui/core/Typography";
// core components
import { TextInput } from 'Ficha/components/TextInput'
import { NumberInput } from 'Ficha/components/NumberInput'
import InputAdornment from '@material-ui/core/InputAdornment';
import CustomSnackbar from "components/Snackbar/CustomSnackbar.js";
import Button from "components/CustomButtons/Button.js";
import Card from "components/Card/Card.js";
import { useForm } from 'react-hook-form'
import { UserContext } from 'context/userContext'
import { criarTabela } from 'firebase/firestoreData'

const useStyles = makeStyles(theme => ({
  field:{
    margin: '10px auto',
  },
  tableBox:{
    padding: 10,
    paddingTop: 20,
  },
  }))


function NewTable(){
  const classes = useStyles()
  const {currentUser} = useContext(UserContext)
  const { register, reset, handleSubmit } = useForm()
  const [showSuccessMessage, setShowSuccessMessage] = useState(false)

  function handleCloseMessage() {
    setShowSuccessMessage(false)
  }

  const onSubmit = data => {
    criarTabela(currentUser.uid, data)
    setShowSuccessMessage(true)
    reset()
  };

  return(
    <Card profile className={classes.tableBox}>
      <Typography gutterBottom>CADASTRAR NOVA TABELA</Typography>
      <Typography variant="caption">Preencha todos os valores para
      cadastrar sua nova tabela</Typography>
      <form onSubmit={handleSubmit(onSubmit)}>
        <TextInput className={classes.fieldNome}
                   required
                   label="Nome da Tabela"
                   name="nomeTabela"
                   ref={register}
        />
        <NumberInput className={classes.field}
                     required
                     label="Porte 0"
                     name="porte0"
                     step="0.01"
                     ref={register}
                     InputProps={{
                      startAdornment: <InputAdornment position="start">R$</InputAdornment>,
                    }}
        />
        <NumberInput className={classes.field}
                     required
                     label="Porte 1"
                     name="porte1"
                     step="0.01"
                     ref={register}
                     InputProps={{
                      startAdornment: <InputAdornment position="start">R$</InputAdornment>,
                    }}
        />
        <NumberInput className={classes.field}
                     required
                     label="Porte 2"
                     name="porte2"
                     step="0.01"
                     ref={register}
                     InputProps={{
                      startAdornment: <InputAdornment position="start">R$</InputAdornment>,
                    }}
        />
        <NumberInput className={classes.field}
                     required
                     label="Porte 3"
                     name="porte3"
                     step="0.01"
                     ref={register}
                     InputProps={{
                      startAdornment: <InputAdornment position="start">R$</InputAdornment>,
                    }}
        />
        <NumberInput className={classes.field}
                     required
                     label="Porte 4"
                     name="porte4"
                     step="0.01"
                     ref={register}
                     InputProps={{
                      startAdornment: <InputAdornment position="start">R$</InputAdornment>,
                    }}
        />
        <NumberInput className={classes.field}
                     required
                     label="Porte 5"
                     name="porte5"
                     step="0.01"
                     ref={register}
                     InputProps={{
                      startAdornment: <InputAdornment position="start">R$</InputAdornment>,
                    }}
        />
        <NumberInput className={classes.field}
                     required
                     label="Porte 6"
                     name="porte6"
                     step="0.01"
                     ref={register}
                     InputProps={{
                      startAdornment: <InputAdornment position="start">R$</InputAdornment>,
                    }}
        />
        <NumberInput className={classes.field}
                     required
                     label="Porte 7"
                     name="porte7"
                     step="0.01"
                     ref={register}
                     InputProps={{
                      startAdornment: <InputAdornment position="start">R$</InputAdornment>,
                    }}
        />
        <NumberInput className={classes.field}
                     required
                     label="Porte 8"
                     name="porte8"
                     step="0.01"
                     ref={register}
                     InputProps={{
                      startAdornment: <InputAdornment position="start">R$</InputAdornment>,
                    }}
        />
        <Button color="primary" round type="submit">
          CADASTRAR
        </Button>
        <CustomSnackbar open={showSuccessMessage} onClose={handleCloseMessage} message={"A tabela foi salva com sucesso"}/>
      </form>
    </Card>
  )
}
export default NewTable
